import React, { useEffect, useState } from "react";
import ProjectsListItem from "./UserSettingsSPVManagerItem";
import "./styles.scss";
import { cloneDeep } from "lodash";
import { Project } from "models/project.model";

interface UserSettingsSPVManagerProps {
  modifiedCurrUser: any;
  setModifiedCurrUser: any;
  setOpenListModal: any;
  projects: Project[];
  setFormDirty: any;
  formDirty: string[];
}
const UserSettingsSPVManager = ({
  modifiedCurrUser,
  setModifiedCurrUser,
  setOpenListModal,
  projects,
  setFormDirty,
  formDirty,
}: UserSettingsSPVManagerProps) => {
  const [
    isSuperAdminForThisModule,
    setIsSuperAdminForThisModule,
  ] = useState<boolean>(false);

  const handleChange = (type: string) => {
    if (type === "setSuperAdmin") {
      if (!formDirty.includes("superadminspvmanager")) {
        let newList = formDirty;
        newList.push("superadminspvmanager");
        setFormDirty(newList);
      }

      let updatedU = cloneDeep(modifiedCurrUser);
      if (isSuperAdminForThisModule) {
        updatedU.privileges["spv-manager"] = [];
        setIsSuperAdminForThisModule(false);
      } else {
        updatedU.privileges["spv-manager"] = [
          {
            details: { type: "project" },
            id: null,
            module: "spv-manager",
            role: "superadmin",
          },
        ];
        setIsSuperAdminForThisModule(true);
      }
      setModifiedCurrUser(updatedU);
    }
  };

  const updateProjectPrivilege = (projectCode: string, role: string) => {
    let newDirtyList = cloneDeep(formDirty);
    newDirtyList.push("spv-" + projectCode);
    setFormDirty(newDirtyList);

    let newUser = cloneDeep(modifiedCurrUser);
    newUser.privileges["spv-manager"].map((priv: any) => {
      if (priv.details["projectCode"] === projectCode) {
        priv.role = role;
      }
    });
    setModifiedCurrUser(newUser);
  };

  const removePrivilege = (projectCode: string) => {
    let newDirtyList = cloneDeep(formDirty);
    newDirtyList.push("spv-" + projectCode);
    setFormDirty(newDirtyList);

    let newUser = cloneDeep(modifiedCurrUser);
    let newListPrivilege = newUser.privileges["spv-manager"];
    newListPrivilege = newUser.privileges["spv-manager"].filter(
      (priv: any) => priv.details["projectCode"] !== projectCode
    );
    newUser.privileges["spv-manager"] = newListPrivilege;
    setModifiedCurrUser(newUser);
  };

  useEffect(() => {
    if (
      modifiedCurrUser &&
      modifiedCurrUser.privileges &&
      modifiedCurrUser.privileges["spv-manager"] &&
      modifiedCurrUser.privileges["spv-manager"].length > 0
    ) {
      if (modifiedCurrUser.privileges["spv-manager"][0].role === "superadmin") {
        setIsSuperAdminForThisModule(true);
      }
    }
  }, []);

  return (
    <div className="user-settings-spv-manager">
      <h3>— general settings</h3>

      <i className="italic">Account status</i>
      <div className="toggle-container">
        <div className="toggle">
          <input
            type="checkbox"
            id="active"
            className="toggle-input"
            onChange={() => handleChange("setSuperAdmin")}
            checked={isSuperAdminForThisModule}
          />
          <div className="toggle-switcher"></div>
        </div>
        <span className="label">Grant super admin privilege</span>
      </div>
      <div className={`state ${isSuperAdminForThisModule ? "warn" : ""}`}>
        {isSuperAdminForThisModule && (
          <>
            <i className="fas fa-exclamation-circle"></i>
            Please be aware that user with super admin access will be able to
            modify all SPV and the Country Data and Country lists.
          </>
        )}
      </div>

      {!isSuperAdminForThisModule && (
        <>
          <div className="separator"></div>

          <div className="title-with-btn">
            <h3>— user privileges by project</h3>
            <button
              className="btn btn-select btn-primary"
              type="button"
              onClick={() => setOpenListModal("project-spv")}
            >
              <span className="btn-label">Add/remove projects</span>
              <span className="btn-icon">
                <i className={`fas fa-arrow-right`}></i>
              </span>
            </button>
          </div>

          <ul className="list">
            <li className="row filters">
              <div className="project">
                <i className="label">Project</i>
              </div>
              <div className="group">
                <i className="label">Set a role</i>
              </div>
              <div className="delete">
                <i className="label">Delete</i>
              </div>
            </li>

            {!!modifiedCurrUser &&
              !!modifiedCurrUser.privileges &&
              !!modifiedCurrUser.privileges["spv-manager"] &&
              modifiedCurrUser.privileges["spv-manager"].length > 0 &&
              modifiedCurrUser.privileges[
                "spv-manager"
              ].map((privilege: any, idx: number) => (
                <ProjectsListItem
                  key={`projectK-${idx}`}
                  privilege={privilege}
                  projects={projects}
                  updateProjectPrivilege={updateProjectPrivilege}
                  formDirty={formDirty}
                  removePrivilege={removePrivilege}
                />
              ))}
          </ul>
        </>
      )}
    </div>
  );
};

export default UserSettingsSPVManager;
